var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.15659 3.3255H2.59035C2.16856 3.3255 1.76405 3.49305 1.4658 3.7913C1.16755 4.08955 1 4.49406 1 4.91585V16.0483C1 16.4701 1.16755 16.8746 1.4658 17.1729C1.76405 17.4711 2.16856 17.6387 2.59035 17.6387H13.7228C14.1446 17.6387 14.5491 17.4711 14.8474 17.1729C15.1456 16.8746 15.3132 16.4701 15.3132 16.0483V10.4821M14.1204 2.13273C14.4368 1.81639 14.8658 1.63867 15.3132 1.63867C15.7605 1.63867 16.1896 1.81639 16.5059 2.13273C16.8223 2.44907 17 2.87812 17 3.3255C17 3.77287 16.8223 4.20192 16.5059 4.51826L8.95176 12.0724L5.77106 12.8676L6.56623 9.68691L14.1204 2.13273Z",
    stroke: "#524E4E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditicon);
export default __webpack_public_path__ + "static/media/Editicon.b07d41c12718865b0fda89ff1c405e2e.svg";
export { ForwardRef as ReactComponent };